import { render } from "./EditStudyPopUp.vue?vue&type=template&id=4dd5fe97&scoped=true"
import script from "./EditStudyPopUp.js?vue&type=script&lang=js"
export * from "./EditStudyPopUp.js?vue&type=script&lang=js"

import "./EditStudyPopUp.vue?vue&type=style&index=0&id=4dd5fe97&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dd5fe97"]])

export default __exports__